export default {
	voteFor: "check",
	voteAgainst: "close",
	voteAbstain: "remove",
	voteExtraOption: "add",
	null: "check",
};
